import { render, staticRenderFns } from "./BBBankTransfers.vue?vue&type=template&id=3cc884a2&lang=pug"
import script from "./BBBankTransfers.vue?vue&type=script&lang=js"
export * from "./BBBankTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports